import { StreamActions } from '@hotwired/turbo';
import { Turbo } from '@hotwired/turbo-rails';

// By default, Turbo takes over all links and forms in the
// application, but we want to adopt it incrementally so we disable it
// by default and explicitly opt-in where we want to use it with the
// `data-turbo` html attribute on a *form* or *link*
//
// For an example of how this all works together, check out the
// `respond_to` calls in pay_schedules_controller.rb compared to its
// _form.erb partial
//
// Docs here!
// https://turbo.hotwired.dev/reference/drive#turbo.session.drive
Turbo.session.drive = false;

// <turbo-stream action="openInNewTab" url="https://google.com"></turbo-stream>
//
StreamActions.openInNewTab = function () {
  window.open(this.getAttribute('url'));
};
